import React, { useState } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import axios from "axios";

const AgencySearch = () => {
    const [formData, setFormData] = useState({
        agencyName: "",
        zipCode: "",
        city: "",
        desigCode: ""
    });

    const [agencies, setAgencies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const isSearchEnabled = Object.values(formData).some((val) => val.trim() !== "");

    const handleSearch = async () => {
        if (!isSearchEnabled) return;

        setLoading(true);
        setError(false); // Reset error state
        try {
            const params = new URLSearchParams({
                name: formData.agencyName.trim() || "",
                zip: formData.zipCode.trim() || "",
                city: formData.city.trim() || "",
                desig: ""
            });

            const apiUrl = `${process.env.REACT_APP_API_URL}/AgenciesLookup?${params.toString()}`;
            
            const response = await axios.get(apiUrl);

            if (response.data.length === 0) {
                setAgencies([]); // No results, clear the table
            } else {
                const sortedAgencies = response.data.sort((a, b) => a.name.localeCompare(b.name));
                setAgencies(groupAgencies(sortedAgencies));
            }
        } catch (error) {
            console.error("Error fetching agencies:", error);
            setError(true);
            setAgencies([]); // Clear results on error
        }
        setLoading(false);
    };

    const groupAgencies = (agencies) => {
        const primaryAgencies = {};
        const branchAgencies = {};

        agencies.forEach((agency) => {
            if (agency.primaryVendorId) {
                if (!branchAgencies[agency.primaryVendorId]) {
                    branchAgencies[agency.primaryVendorId] = [];
                }
                branchAgencies[agency.primaryVendorId].push(agency);
            } else {
                primaryAgencies[agency.vendorId] = agency;
            }
        });

        const orderedList = [];
        Object.values(primaryAgencies).forEach((primary) => {
            orderedList.push(primary);
            if (branchAgencies[primary.vendorId]) {
                const sortedBranches = branchAgencies[primary.vendorId].sort((a, b) => a.name.localeCompare(b.name));
                orderedList.push(...sortedBranches);
            }
        });

        return orderedList;
    };

    return (
        <Container>
            <Row className="justify-content-center">
                <Col md={8}>
                    <div style={{ backgroundColor: "#f8f9fa", padding: "30px", borderRadius: "10px", boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)" }}>
                        <h2 style={{ marginBottom: "20px" }}>Search for Agencies</h2>
                        <Form>
                            <Form.Group controlId="agencyName" style={{ marginBottom: "15px" }}>
                                <Form.Label>Agency Name</Form.Label>
                                <Form.Control type="text" name="agencyName" value={formData.agencyName} onChange={handleChange} />
                            </Form.Group>
                            <Form.Group controlId="zipCode" style={{ marginBottom: "15px" }}>
                                <Form.Label>Zip Code</Form.Label>
                                <Form.Control type="text" name="zipCode" value={formData.zipCode} onChange={handleChange} />
                            </Form.Group>
                            <Form.Group controlId="city" style={{ marginBottom: "15px" }}>
                                <Form.Label>City</Form.Label>
                                <Form.Control type="text" name="city" value={formData.city} onChange={handleChange} />
                            </Form.Group>
                            <Button variant="primary" onClick={handleSearch} disabled={!isSearchEnabled || loading}>
                                {loading ? "Searching..." : "Search"}
                            </Button>
                        </Form>
                    </div>

                    {/* Show error message if an error occurred */}
                    {error && (
                        <div style={{ color: "red", marginTop: "15px" }}>
                            <strong>No Agencies returned for the above parameters. Please try again.</strong>
                        </div>
                    )}

                    {/* Only show results table if agencies exist */}
                    {agencies.length > 0 && !error && (
                        <div style={{ marginTop: "20px" }}>
                            <h3>Results</h3>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Agency Name</th>
                                        <th>Desig Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {agencies.map((agency, index) => (
                                        <tr key={index}>
                                            <td>
                                                {agency.primaryVendorId ? <span>&nbsp;&nbsp;&nbsp;</span> : ""}
                                                {agency.name}
                                            </td>
                                            <td>{agency.vendorId.slice(-5)}</td> {/* Show last 5 digits of vendorId */}
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default AgencySearch;
